export const CHAT_KIND = {
  application: 'application',
  appeal: 'appeal',
  guest: 'guest',
  alj_denied: 'alj_denied'
};
